import styled from "styled-components"

export const PageWidth = styled.div`
  width: min(1160px, calc(100% - 96px));
  margin-inline: auto;
  @media (max-width: 700px) {
    width: calc(100% - 40px);
  }
`

export const Eyebrow = styled.p`
  font-size: 12px;
  line-height: 1.5;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 600;
  color: ${p => p.theme.muted};
`

export const Section = styled.section`
  padding: 64px 0 72px;
  @media (max-width: 700px) {
    padding: 48px 0 56px;
  }
`

export const SectionHeading = styled.h2`
  font-size: clamp(28px, 3.2vw, 40px);
  line-height: 1.18;
  font-weight: 600;
  letter-spacing: -0.045em;
  margin: 16px 0 36px;
  max-width: 620px;
`
